import type { FC } from "react";

import { getStoreFilterCategoryIcon } from "@locators/components/shared/utils/getStoreFiltersIcons";
import type { ProductAttribute } from "@locators/components/StoreLocator";

import { SelectionTileItem } from "@jti/core-components";

import styles from "../StoreDetailsProductsByBrand.module.scss";

type FlavourTileProps = {
  flavour: NonNullable<ProductAttribute["values"]>[0];
  attribute: ProductAttribute;
  groupName: string;
};

export const FlavourTile: FC<FlavourTileProps> = ({ flavour, attribute, groupName }) => (
  <SelectionTileItem
    value={String(flavour.value)}
    label={String(flavour.value)}
    name={groupName}
    readOnly
    icon={getStoreFilterCategoryIcon({
      categoryKey: attribute.key,
      filterKey: String(flavour.value),
      filtersItemIconContainerClassName: styles.storeDetailsProductsColor,
    })}
  />
);
